import './App.css';

import { SessionExpiredDialog } from '@rio-cloud/rio-session-expired-info';
import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import NotificationsContainer from '@rio-cloud/rio-uikit/NotificationsContainer';
import { useRef } from 'react';
import {Outlet, useParams} from "react-router";

import { getDisplayMessages, getLocale } from '@/configuration/lang/langSlice';
import { isUserSessionExpired } from '@/configuration/login/loginSlice';
import { useAppDispatch, useAppSelector } from '@/configuration/setup/hooks';
import { getSessionExpiredAcknowledged, hideSessionExpiredDialog } from '@/store/app/appSlice';

import Header from '../components/organism/Header/Header';
import { AppContext } from './AppContext';
import NavigationResolver from './NavigationResolver';

const AppLayout = () => {
  const dispatch = useAppDispatch();

  const { section, subsection } = useParams();
  const sidebarRef = useRef<HTMLDivElement>(null);

  const userLocale = useAppSelector(getLocale);
  const displayMessages = useAppSelector(getDisplayMessages);
  const isSessionExpired = useAppSelector(isUserSessionExpired);
  const sessionExpiredAcknowledged = useAppSelector(getSessionExpiredAcknowledged);

  if (!(displayMessages && userLocale)) {
    return null;
  }

  const handleSessionExpiredDialogClose = () => dispatch(hideSessionExpiredDialog());
  const showSessionExpired = isSessionExpired && !sessionExpiredAcknowledged;

  return (
    <NavigationResolver section={section} subsection={subsection}>
      <AppContext.Provider value={{ sidebarRef }}>
        <ApplicationLayout data-testid={'app-layout'} className="bg-lighter">
          <ApplicationLayout.Header>
            <Header />
          </ApplicationLayout.Header>
          <NotificationsContainer />
          <SessionExpiredDialog locale={userLocale} onClose={handleSessionExpiredDialogClose} show={showSessionExpired} />
          <Outlet />
        </ApplicationLayout>
      </AppContext.Provider>
    </NavigationResolver>
  );
};

export default AppLayout;
